import { createReducer, on } from '@ngrx/store';
import { 
    importRecord,
    importRecordSuccess,
    resetState,
} from './bulk-import.action';

export interface BulkImportRecordsState {
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: BulkImportRecordsState = {
    loading: false,
    error: null,
    total: 0,
};

export const BulkImportRecordReducer = createReducer(

    initialState,

    //Fetch All Records
    on(importRecord, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(importRecordSuccess, (state) => {
        return { ...state, loading: false, error: null };
    }),

    //Reset
    on(resetState, () => initialState)  // Reset action handler
    
);